import React from 'react';
import SimpleTutorialSection from './SimpleTutorialSection';

interface FormulariosWrapperProps {
  children: React.ReactNode;
  onSectionChange?: (section: string) => void;
  onDimensionSelect?: (dimensionId: number) => void;
  onViewModeChange?: (mode: 'student' | 'skill') => void;
}

const FormulariosWrapper: React.FC<FormulariosWrapperProps> = ({ 
  children,
  onDimensionSelect,
  onViewModeChange
}) => {
  return (
    <SimpleTutorialSection 
      section="formularios"
      onDimensionSelect={onDimensionSelect}
      onViewModeChange={onViewModeChange}
    >
      <div className="bg-white p-4 rounded-lg shadow-md">
        {/* Agregar clases CSS necesarias para el tutorial */}
        <div className="dimension-categories">
          {children}
        </div>
      </div>
    </SimpleTutorialSection>
  );
};

export default FormulariosWrapper;
